import {Compact} from 'vue-color';
import Vue from 'vue';

Vue.component('compact-picker', Compact);